import request from '@/utils/request'

// 批量分配负责人
export function batchChangeManager(data) {
  return request({
    url: '/crmAssign/batchChangeManager',
    method: 'post',
    data: data
  })
}
